import React from "react";
import { readableText } from "./../../widget/public/shared/colorUtils";

// The wall hero: headline, subtext, call-to-action button. Every theme shows
// it, but the four original themes (Cards, Bubbles, Chats, Futuristic) each
// style their own heading, so the heading classes are passed in rather than
// fixed here. WallChrome passes its own defaults for the forked themes.
//
// All four fields live in the wall's design jsonb and are individually
// optional. hero_headline falls back to the older `intro` field, which is
// what walls built before the hero existed have set. Nullish rather than ||,
// so clearing the headline on purpose stays cleared.
// hero_enabled defaults to true when absent, so walls that predate the toggle
// keep showing their heading.
export const heroFields = (wall) => {
  const design = wall.design || {};
  const enabled = design.hero_enabled !== false;
  const headline = design.hero_headline ?? wall.intro ?? "";
  const subtext = design.hero_subtext || "";
  const ctaLabel = design.hero_cta_label || "";
  const ctaUrl = design.hero_cta_url || "";
  return {
    enabled,
    headline,
    subtext,
    ctaLabel,
    ctaUrl,
    hasCta: !!(ctaLabel && ctaUrl),
    any: enabled && !!(headline || subtext || (ctaLabel && ctaUrl)),
  };
};

const WallHero = ({
  wall,
  accent = "#3E8DFF",
  headingClassName = "zz-display text-4xl sm:text-6xl font-black leading-[1.05] mt-4 mx-auto max-w-4xl",
  headingStyle,
  subtextClassName = "mt-5 text-base sm:text-lg leading-relaxed opacity-80 mx-auto max-w-2xl whitespace-pre-line",
  ctaClassName = "inline-flex items-center justify-center px-7 py-3.5 rounded-lg font-bold text-base no-underline transition-transform hover:-translate-y-0.5",
  ctaWrapClassName = "mt-8",
}) => {
  const { enabled, headline, subtext, ctaLabel, ctaUrl, hasCta } = heroFields(wall);

  if (!enabled) return null;

  return (
    <>
      {headline && (
        <h1 className={headingClassName} style={headingStyle}>
          {headline}
        </h1>
      )}

      {subtext && <p className={subtextClassName}>{subtext}</p>}

      {hasCta && (
        <div className={ctaWrapClassName}>
          <a
            href={ctaUrl}
            target="_blank"
            rel="noopener noreferrer"
            className={ctaClassName}
            style={{ backgroundColor: accent, color: readableText(accent) }}
          >
            {ctaLabel}
          </a>
        </div>
      )}
    </>
  );
};

export default WallHero;
